import { createContext, useContext } from "react";

interface CredentialSaveContextValue {
  credentialId: number;
  integration: string;
  credentials: Record<string, string>;
  settings: Record<string, string>;
}

export const CredentialSaveContext =
  createContext<CredentialSaveContextValue | null>(null);

export const useCredentialSaveContext = () => useContext(CredentialSaveContext);
